export default __webpack_public_path__ + "static/country_side-1fe08176f681841d3befa49d3ece51d8.jpg";